import { render, staticRenderFns } from "./Hub.vue?vue&type=template&id=708e00c1&scoped=true&"
import script from "./Hub.vue?vue&type=script&lang=js&"
export * from "./Hub.vue?vue&type=script&lang=js&"
import style0 from "./Hub.vue?vue&type=style&index=0&id=708e00c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e00c1",
  null
  
)

export default component.exports